import {  Snackbar } from '@mui/material'
import React from 'react'
import MuiAlert from '@mui/material/Alert';



const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

// Defensive renderer: callers sometimes pass `err.response.data` directly,
// which can be an object (e.g. {error: "...", code: "..."}). Rendering an
// object as a React child throws and unmounts the whole page, so coerce to
// a readable string here.
const toMessage = (m) => {
  if (m == null) return "Something went wrong";
  if (typeof m === "string") return m;
  if (typeof m === "object") {
    return m.error || m.msg || m.message || JSON.stringify(m);
  }
  return String(m);
};

const ErrorSnackbar = ({open,handleClose,message}) => {
  return (
    <>
      <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error"  sx={{width:"100%"}}>
                {toMessage(message)}
          </Alert>
      </Snackbar>   
    </>
  )
}

export default ErrorSnackbar
